import CONSTANTS from '../constants'
import { getRequest,postRequest } from '../../services'
import { APICONFIG } from '../config/apiConfig'
import { addEventLog } from '../../pages/warningCitation/redux/actions/EventsLog'

// Calls the API to get Facility Initials
export const getFacilityList = (partner, otherParams = {}) => (dispatch) => {
    // PIMS-10130
	// dispatch(addEventLog(partner, CONSTANTS.GET_FACILITY_REQUEST))
	dispatch({ type: CONSTANTS.GET_FACILITY_REQUEST })
	let endpoint = `${APICONFIG.getFacilityList}/${partner}`
	if(otherParams?.services && otherParams?.services != ''){
		endpoint = `${endpoint}/${otherParams?.services}`
	}
	if(otherParams?.permittype && otherParams?.permittype != ''){
		endpoint = `${endpoint}/${otherParams?.permittype}`
	}

	return getRequest(endpoint).then((res) => {
		// let resObject = { ...res, 'partner' : partner }
		// dispatch(addEventLog(resObject, CONSTANTS.GET_FACILITY_SUCCESS))
		dispatch({ type: CONSTANTS.GET_FACILITY_SUCCESS, data: res.data })
		return res.data
	}).catch(() => {
		// let errObject = { ...err, 'partner' : partner }
		// dispatch(addEventLog(errObject, CONSTANTS.GET_FACILITY_FAILURE))
		dispatch({ type: CONSTANTS.GET_FACILITY_FAILURE })
	})
}

//Permit rate list
// export const permitRateList = (data) => (dispatch) => {
// 	dispatch({ type: CONSTANTS.GET_PERMIT_RATE_LIST_REQUEST })
// 	return getRequest(`${APICONFIG.getPermitRateListUrl}?facility_id=${data?.facility_id}&&driving_license=${data?.driving_license}`).then((res) => {
// 		dispatch({ type: CONSTANTS.GET_PERMIT_RATE_LIST_SUCCESS, data: res })
// 		return res
// 	}).catch(() => {
// 		dispatch({ type: CONSTANTS.GET_PERMIT_RATE_LIST_FAILURE })
// 	})
// }

//Permit rate list
export const permitRateList = (data) => (dispatch) => {
	dispatch(addEventLog(data, CONSTANTS.GET_PERMIT_RATE_LIST_REQUEST))
	dispatch({ type: CONSTANTS.GET_PERMIT_RATE_LIST_REQUEST })
	return getRequest(`${APICONFIG.getArePermitRateListUrl}?facility_id=${data?.facility_id}&driving_license=${data?.driving_license}&is_promotion=${data?.is_promotion}&category_id=${data?.category_id}${data?.is_permit_type == '1' ? '&is_permit_type=1' : ''}`).then((res) => {
		let resObject = { ...data, ...res }
		dispatch(addEventLog(resObject, CONSTANTS.GET_PERMIT_RATE_LIST_SUCCESS))
		dispatch({ type: CONSTANTS.GET_PERMIT_RATE_LIST_SUCCESS, data: res })
		return res
	}).catch((err) => {
		let errObject = { ...data, ...err }
		dispatch(addEventLog(errObject, CONSTANTS.GET_PERMIT_RATE_LIST_FAILURE))
		dispatch({ type: CONSTANTS.GET_PERMIT_RATE_LIST_FAILURE })
	})
}

//Permit Category list
export const permitCategoryList = (partnerId, category = '') => (dispatch) => {
	const payload = {
		partner : partnerId,
		category : category
	}
	dispatch(addEventLog(payload, CONSTANTS.GET_PERMIT_CATEGORY_LIST_REQUEST))
	dispatch({ type: CONSTANTS.GET_PERMIT_CATEGORY_LIST_REQUEST })
	let endPoint = `${APICONFIG.getPermitCategoryListUrl}?partner_id=${partnerId}`
	if(category && category != ''){
		endPoint = `${endPoint}&is_promotion=2`
	}
	return getRequest(endPoint).then((res) => {
		let resObject = { ...payload, ...res }
		dispatch(addEventLog(resObject, CONSTANTS.GET_PERMIT_CATEGORY_LIST_SUCCESS))
		dispatch({ type: CONSTANTS.GET_PERMIT_CATEGORY_LIST_SUCCESS, data: res })
		return res
	}).catch((err) => {
		let errObject = { ...payload, ...err }
		dispatch(addEventLog(errObject, CONSTANTS.GET_PERMIT_CATEGORY_LIST_FAILURE))
		dispatch({ type: CONSTANTS.GET_PERMIT_CATEGORY_LIST_FAILURE })
	})
}

//Permit Category list
export const permitCategoryServiceList = (payloadGetService) => (dispatch) => {
	dispatch(addEventLog(payloadGetService, CONSTANTS.GET_PERMIT_CATEGORY_SERVICE_REQUEST))
	dispatch({ type: CONSTANTS.GET_PERMIT_CATEGORY_SERVICE_REQUEST })
	return postRequest(APICONFIG.getPermitCategoryServiceUrl,payloadGetService).then((res) => {
		let resObject = { ...payloadGetService, ...res }
		dispatch(addEventLog(resObject, CONSTANTS.GET_PERMIT_CATEGORY_SERVICE_SUCCESS))
		dispatch({ type: CONSTANTS.GET_PERMIT_CATEGORY_SERVICE_SUCCESS, data: res })
		return res
	}).catch((err) => {
		let errObject = { ...payloadGetService, ...err }
		dispatch(addEventLog(errObject, CONSTANTS.GET_PERMIT_CATEGORY_SERVICE_FAILURE))
		dispatch({ type: CONSTANTS.GET_PERMIT_CATEGORY_SERVICE_FAILURE })
	})
}


// OPEN MODAL ACTION
	export const modalAction = (data) => (dispatch) => {
		dispatch({ type: CONSTANTS.OPEN_MODAL, isModalOpen: data })
		// return data
	}

	// updated user-Profile
export const checkIfValidUserExists = (data) => (dispatch) => {
    let payload = {...data, 'device_type': 'web'}
    dispatch(addEventLog(payload, CONSTANTS.GET_USER_VALID_CHECK_REQUEST))
    dispatch({ type: CONSTANTS.GET_USER_VALID_CHECK_REQUEST })
    return postRequest(APICONFIG.checkUserValidityUrl, payload).then((res) => {
        let resObject = { ...payload, ...res }
        dispatch(addEventLog(resObject, CONSTANTS.GET_USER_VALID_CHECK_SUCCESS))
        dispatch({ type: CONSTANTS.GET_USER_VALID_CHECK_SUCCESS, data: res })
        return res
    }).catch((err) => {
        let errObject = { ...payload, ...err }
        dispatch(addEventLog(errObject, CONSTANTS.GET_USER_VALID_CHECK_FAILURE))
        dispatch({ type: CONSTANTS.GET_USER_VALID_CHECK_FAILURE })
        return err
    })
}

export const getPermitByEmail = (data) => (dispatch) => {
	let payload = { ...data }
	dispatch(addEventLog(payload, CONSTANTS.GET_USER_EMAILID_CHECK_REQUEST))
	dispatch({ type: CONSTANTS.GET_USER_EMAILID_CHECK_REQUEST })
	return postRequest(APICONFIG.getPermitTypeByEMailURL, payload).then((res) => {
		let resObject = { ...payload, ...res }
		dispatch(addEventLog(resObject, CONSTANTS.GET_USER_EMAILID_CHECK_SUCCESS))
		dispatch({ type: CONSTANTS.GET_USER_EMAILID_CHECK_SUCCESS, data: res })
		return res
	}).catch((err) => {
		let errObject = { ...payload, ...err }
		dispatch(addEventLog(errObject, CONSTANTS.GET_USER_EMAILID_CHECK_FAILURE))
		dispatch({ type: CONSTANTS.GET_USER_EMAILID_CHECK_FAILURE })
		return err
	})
}

export const getDocumentTypes = (facility_id = '') => (dispatch) => {
	const payload = {
		permit_id : facility_id
	}
	dispatch(addEventLog(payload, CONSTANTS.GET_DOCUMENT_TYPES_REQUEST))
	dispatch({ type: CONSTANTS.GET_DOCUMENT_TYPES_REQUEST })
	let api_url
	if(facility_id){
		api_url = `${APICONFIG.getDocumentTypeUrl}/${facility_id}`
		// api_url = `${APICONFIG.getDocumentTypeUrl}/4`
	}else{
		api_url = `${APICONFIG.getDocumentTypeUrl}`
	}
	return getRequest(api_url).then((res) => {
		let resObject = {...payload, ...res} 
        dispatch(addEventLog(resObject, CONSTANTS.GET_DOCUMENT_TYPES_SUCCESS))
		dispatch({ type: CONSTANTS.GET_DOCUMENT_TYPES_SUCCESS, data: res?.data })
		return res?.data
	}).catch((err) => {
		let errObject = {...payload, ...err} 
        dispatch(addEventLog(errObject, CONSTANTS.GET_DOCUMENT_TYPES_FAILURE))
		dispatch({ type: CONSTANTS.GET_DOCUMENT_TYPES_FAILURE })
		return err
	})
}
